<template>
  <div>
    <a-tabs 
      :default-active-key="key" v-model="key"
    >
      <a-tab-pane :key="1">
        <span slot="tab">
          <a-icon type="shop" />
          {{ $t('approvalRequest.shopVisitation') }}
        </span>
        <ShopHistory v-if="key == 1"/>
      </a-tab-pane>
      <a-tab-pane :key="2">
        <span slot="tab">
          <a-icon type="flag" />
          {{ $t('approvalRequest.communeVisitation') }}
        </span>
        <CommuneHistory v-if="key ==2"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import CommuneHistory from './history-list.vue'
import ShopHistory from './shop-request-checkin-history.vue'
export default {
  name: 'historyTap',
  components: {
    CommuneHistory,
    ShopHistory
  },
  data() {
    return {
      key: 1
    }
  },
}
</script>
